import type { CustomFlowbiteTheme } from "flowbite-react";

/**
 * Flowbite component theme overrides.
 * Class strings use semantic design-system tokens where possible so
 * light/dark values propagate through CSS variables.
 */
export const PrimaryTheme: CustomFlowbiteTheme = {
  button: {
    base: "active:scale-95 font-normal p-1 flex justify-center items-center",
    color: {
      primary:
        "bg-lgb-primary border border-transparent hover:bg-lgb-primary-lighten text-white",
      primaryDynamic:
        "border border-transparent text-white",
      primary700: "bg-lgb-primary-700 hover:bg-lgb-primary-400 text-white",
      primaryPurple:
        "text-white border border-transparent active:scale-95 bg-brand hover:bg-brand-hover focus:ring-4 focus:outline-none focus:ring-brand font-medium rounded-lg text-sm px-1 text-center inline-flex items-center me-4",
      red300: "bg-danger hover:bg-danger-hover text-white",
      mainGreen: "bg-success hover:bg-success-hover text-white",
      green400: "bg-success",
      green300: "bg-success hover:bg-success-hover text-white",
      blue400: "bg-brand-muted hover:bg-brand text-white",
    },
  },
  textInput: {
    field: {
      input: {
        colors: {
          primary: "text-red",
          gray: "border-border-strong bg-surface-input text-text placeholder:text-placeholder focus:border-brand focus:ring-brand dark:border-border-strong dark:bg-surface-input dark:text-text dark:placeholder:text-placeholder",
        },
      },
    },
  },
  textarea: {
    base: "block w-full border border-border-strong bg-surface-input text-text placeholder:text-placeholder dark:bg-surface-input dark:border-border dark:text-text dark:placeholder:text-placeholder focus:border-brand focus:ring-brand rounded-lg p-2.5 text-sm",
    colors: {
      gray: "bg-surface-input text-text dark:bg-surface-input dark:text-text",
      info: "bg-blue-50 text-blue-900 dark:bg-blue-900 dark:text-blue-50",
      failure: "bg-red-50 text-red-900 dark:bg-red-900 dark:text-red-50",
      warning: "bg-yellow-50 text-yellow-900 dark:bg-yellow-900 dark:text-yellow-50",
      success: "bg-green-50 text-green-900 dark:bg-green-900 dark:text-green-50",
    }
  },
  label: {
    root: {
      colors: {
        default: "text-text",
      },
    },
  },
  select: {
    field: {
      select: {
        colors: {
          gray: "block w-full border disabled:cursor-not-allowed disabled:opacity-50 bg-surface-input border-border-strong text-text placeholder:text-placeholder focus:border-brand focus:ring-brand rounded-lg p-2.5 text-sm dark:bg-surface-input dark:border-border dark:text-text dark:placeholder:text-placeholder",
        },
      },
    },
  },
  sidebar: {
    root: {
      inner:
        "h-full overflow-y-auto overflow-x-hidden bg-surface-muted py-4 px-3 dark:bg-surface",
    },
  },
  modal: {
    root: {
      base: "fixed inset-0 z-50 flex items-center justify-center bg-overlay sm:p-6",
      show: {
        on: "flex items-center justify-center",
        off: "hidden",
      },
      sizes: {
        sm: "w-full h-full",
        md: "max-w-2xl h-auto w-auto",
        lg: "max-w-3xl h-auto w-auto",
        xl: "max-w-6xl h-auto w-auto",
      },
    },

    content: {
      base: "relative flex flex-col w-full sm:w-auto sm:max-h-[90vh] rounded-lg shadow-lg border border-border-strong bg-surface-modal overflow-hidden",
    },

    body: {
      base: "bg-surface-modal flex-1 overflow-auto px-6 pb-6 pt-2",
    },

    header: {
      base: "bg-surface-modal flex items-start justify-between rounded-t border-b border-border-strong px-4 py-3",
    },
  },

  card: {
    root: {
      base: "shadow-custom border border-border-subtle rounded-lg p-4 bg-surface dark:bg-surface",
    },
    img: {
      base: "rounded-t-lg",
    },
  },
};
